import PropTypes from "prop-types";
const { Backdrop, CircularProgress } = require("@mui/material");

const LoaderWithBackdrop = ({ loader }) => {
  return (
    <Backdrop
      sx={{ zIndex: (theme) => theme.zIndex.tooltip + 1 }}
      open={loader}
      // onClick={handleClose}
    >
      <CircularProgress />
    </Backdrop>
  );
};

LoaderWithBackdrop.propTypes = {
  loader: PropTypes.bool,
};

export default LoaderWithBackdrop;
